module.exports = __webpack_public_path__ + "img/case-gardner.05ccfc82.png";